import {
  FETCH_CURRENT_INVENTORY, 
  FETCH_CURRENT_INVENTORY_SUCCESS, 
  RESET_INVENTORY_ITEM,
  FETCH_INVENTORY_ITEM,
  FETCH_INVENTORY_ITEM_CARTONS,
  FETCH_INVENTORY_ITEM_CARTONS_SUCCESS,
  FETCH_INVENTORY_ITEM_BY_CARTON_ID, 
  FETCH_INVENTORY_ITEM_SUCCESS,
  FETCH_INVENTORY_ITEM_ERROR,
  RESET_INSPECTION_LOCATION_SUCCESS_DETAILS,
  UPDATE_INSPECTION_LOCATION,
  UPDATE_INSPECTION_LOCATION_SUCCESS,
  ON_SHOW_LOADER, ON_HIDE_LOADER,
  CREATE_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_ERROR,
  CREATE_PRODUCT_CLEAR,
} from "../constants/ActionTypes";

export const fetchCurrentInventory = (data) => {
  return {
    type: FETCH_CURRENT_INVENTORY,
    payload: data
  };
};
export const fetchCurrentInventorySuccess = data => {
  return {
    type: FETCH_CURRENT_INVENTORY_SUCCESS,
    payload: data
  };
};

export const resetInventoryItem = () => {
  return {
    type: RESET_INVENTORY_ITEM,
  };
};
export const fetchInventoryItemCartons = (data) => {
  return {
    type: FETCH_INVENTORY_ITEM_CARTONS,
    payload: data
  };
};
export const fetchInventoryItemCartonsSuccess = (data) => {
  return {
    type: FETCH_INVENTORY_ITEM_CARTONS_SUCCESS,
    payload: data
  };
};
export const fetchInventoryItemByCartonId = (data) => {
  return {
    type: FETCH_INVENTORY_ITEM_BY_CARTON_ID,
    payload: data
  };
};
export const fetchInventoryItem = (data) => {
  return {
    type: FETCH_INVENTORY_ITEM,
    payload: data
  };
}; 
export const fetchInventoryItemSuccess = data => {
  return {
    type: FETCH_INVENTORY_ITEM_SUCCESS,
    payload: data,
  };
};
export const fetchInventoryItemError = data => {
  return {
    type: FETCH_INVENTORY_ITEM_ERROR,
    payload: data
  };
};

export const updateInspectionLocation = (data) => {
  return {
    type: UPDATE_INSPECTION_LOCATION,
    payload: data
  };
};
export const updateInspectionLocationSuccess = inspection => {
  return {
    type: UPDATE_INSPECTION_LOCATION_SUCCESS,
    payload: inspection
  };
};
export const resetInspectionLocationSuccessDetails = () => {
  return {
    type: RESET_INSPECTION_LOCATION_SUCCESS_DETAILS,
  };
};


export const showLoader = () => {
  return {
      type: ON_SHOW_LOADER,
  };
};
export const hideLoader = () => {
  return {
      type: ON_HIDE_LOADER,
  };
};

export const createInventoryProduct = (data) => {
  return {
    type: CREATE_PRODUCT,
    payload: data,
  };
};
export const createInventoryProductSuccess = (data) => {
  return {
    type: CREATE_PRODUCT_SUCCESS,
    payload: data,
  };
};
export const createInventoryProductError = (data) => {
  return {
    type: CREATE_PRODUCT_ERROR,
    payload: data,
  };
};
export const createInventoryProductClear = () => {
  return {
    type: CREATE_PRODUCT_CLEAR,
  };
};
